module.exports = __webpack_public_path__ + "img/loadBank.995d6435.png";